import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import TestimonialOneLinerContainer from 'src/app/organisms/Homepage/TestimonialOneLinerContainer/TestimonialOneLinerContainer';

const Testimonial = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-none', 'spacing-4xl', 'spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl', 'spacing-4xl', 'spacing-xl']}
  >
    <TestimonialOneLinerContainer />
  </SectionLayout>
);

export default Testimonial;
